import { useUserInfo } from "@redux/slices/userInfoSlice";
import { useTypographyStore } from "@redux/slices/typographySlice";
import { useSelector } from "react-redux";
import { useTheme } from "styled-components/native";
import { useTranslation } from "react-i18next";

const useScreenOptionsHooks = () => {
  const { user } = useUserInfo();
  const theme = useTheme();
  const typography = useTypographyStore();
  const { t } = useTranslation();
  const activeProduct = useSelector(
    (state: any) => state.appState?.activeProduct
  );
  const requestScreenColor = useSelector(
    (state: any) => state.appState?.requestScreenColor
  );

  return {
    user,
    theme,
    typography,
    activeProduct,
    requestScreenColor,
    t,
  };
};

export default useScreenOptionsHooks;
